
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialReceiptGrid extends Serenity.EntityGrid<MaterialReceiptRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialReceipt'; }
        protected getDialogType() { return MaterialReceiptDialog; }
        protected getIdProperty() { return MaterialReceiptRow.idProperty; }
        protected getInsertPermission() { return MaterialReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialReceiptRow.localTextPrefix; }
        protected getService() { return MaterialReceiptService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(41);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[41].AutoPosting;
            this.editItem(<MaterialReceiptRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 41,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}